import PaymentMethodsRegistration from './PaymentMethodsRegistration';

export default PaymentMethodsRegistration;
